import {Permissions} from 'mattermost-redux/constants';
import {isCustomGroupsEnabled} from 'mattermost-redux/selectors/entities/preferences';
import {haveISystemPermission} from 'mattermost-redux/selectors/entities/roles_helpers';
import {type GlobalState} from 'types/store';

export const isGroupMembersViewAvailable = (state: GlobalState) => {
    return haveISystemPermission(state, {permission: Permissions.VIEW_CUSTOM_GROUP}) && isCustomGroupsEnabled(state);
};
